import * as React from "react";
import {
  ApplyingRule,
  ConditionSet,
  IFunctionElementUnion,
  IStaticElementUnion,
  InputElementUnion,
} from "@graffer-inc/form-schema";
import { ApplicantThenRuleEditor } from "./applicant-rule-editor";
import {
  ApplicantSchemaKeys,
  checkNotSupportedRule,
} from "@graffer-inc/cloud-gov-core";
import { ApplicantThenRuleDisableEditor } from "./applicant-rule-disable-editor";
import { matchType } from "../../../../../../application/domain/base/base-type";
import { ApplicantTypeLiterals } from "../../../../../../application/domain/application/application-entity";
import { PublishedSchemaApplicantThenRuleEditor } from "./published-schema-applicant-rule-editor";
import { IRepeatableElementUnion } from "@graffer-inc/form-schema/dist/elements-schema/repeatable-schema";

export const ThenRulesEditor: React.FC<{
  ifSet: ConditionSet;
  thenRules: ApplyingRule[];
  thenCandidates: Array<
    | InputElementUnion
    | IFunctionElementUnion
    | IStaticElementUnion
    | IRepeatableElementUnion
  >;
  thenDisplayFilter?: (rule: ApplyingRule) => boolean;
  onUpdate: (applyingRule: ApplyingRule[]) => void;
  applicantSchemaKeys: ApplicantSchemaKeys;
  isSafeEditOnly: boolean;
}> = ({
  ifSet,
  thenRules,
  thenCandidates,
  thenDisplayFilter = () => true,
  onUpdate,
  applicantSchemaKeys,
  isSafeEditOnly,
}) => {
  return (
    <>
      <div className="columns is-vcentered">
        <div className="column">
          {thenRules.map((r, index) => {
            if (!thenDisplayFilter(r)) {
              return null;
            }
            const targetElement = thenCandidates.find((e) => e.id === r.id);

            return (
              <>
                {checkNotSupportedRule(ifSet, r, applicantSchemaKeys) ? (
                  <ApplicantThenRuleDisableEditor
                    ifTypeLabel={matchType(
                      ifSet.conditions[0].match.const as ApplicantTypeLiterals,
                      {
                        CORPORATE: "法人",
                        INDIVIDUAL: "個人",
                        UNINCORPORATED_GROUP: "団体",
                      },
                    )}
                    thenRule={r}
                    thenCandidates={thenCandidates}
                  />
                ) : (
                  targetElement && (
                    <>
                      {isSafeEditOnly ? (
                        <PublishedSchemaApplicantThenRuleEditor
                          thenRule={r}
                          thenCandidates={thenCandidates}
                          element={targetElement}
                        />
                      ) : (
                        <ApplicantThenRuleEditor
                          thenRule={r}
                          thenCandidates={thenCandidates}
                          element={targetElement}
                          onUpdate={(newRule) => {
                            onUpdate(
                              thenRules.map((rule, i) => {
                                if (index === i) {
                                  return newRule;
                                } else {
                                  return rule;
                                }
                              }),
                            );
                          }}
                        />
                      )}
                    </>
                  )
                )}
                <hr />
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};
